// project imports

// assets
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import BorderOuterOutlined from '@ant-design/icons/BorderOuterOutlined';
import ContactsOutlined from '@ant-design/icons/ContactsOutlined';
import LockOutlined from '@ant-design/icons/LockOutlined';
import QrcodeOutlined from '@ant-design/icons/QrcodeOutlined';
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';
import SolutionOutlined from '@ant-design/icons/SolutionOutlined';
// type
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const restaurant: NavItemType = {
  id: 'group-restaurant',
  title: '',
  icon: AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: 'workers',
      title: 'Workers',
      type: 'item',
      url: '/restaurant/workers',
      icon: SolutionOutlined,
      breadcrumbs: false
    },
    {
      id: 'shifts',
      title: 'Shifts',
      type: 'item',
      icon: ContactsOutlined,
      url: '/restaurant/shifts',
      breadcrumbs: false
    },
    {
      id: 'reservations',
      title: 'Reservations',
      type: 'item',
      url: '/restaurant/reservations',
      nonApiUrl: '/restaurant/customer-requests',
      icon: ScheduleOutlined
      // actions: [
      //   {
      //     type: NavActionType.LINK,
      //     label: 'Full Calendar',
      //     icon: icons.LinkOutlined,
      //     url: 'https://fullcalendar.io/docs/react',
      //     target: true
      //   }
      // ]
    },
    {
      id: 'tables',
      title: 'Table coverage',
      type: 'item',
      icon: BorderOuterOutlined,
      url: '/restaurant/tables',
      breadcrumbs: false
    },
    {
      id: 'qr-codes',
      title: 'QR Codes',
      type: 'item',
      icon: QrcodeOutlined,
      url: '/restaurant/qr-codes',
      breadcrumbs: false
    },
    {
      id: 'requests',
      title: 'Requests',
      type: 'item',
      icon: LockOutlined,
      url: '/restaurant/requests',
      breadcrumbs: false
    }
  ]
};

export default restaurant;
